import { useEffect, useState } from "react"
import { getAuth, onAuthStateChanged } from "firebase/auth"
import { fetchUserDetails } from '../utilities/authUtils';

export const useAuthStatus = () => {
    const [loggedIn, setLoggedIn] = useState(false)
    const [isAdmin, setIsAdmin] = useState(false);
    const [checkingStatus, setCheckingStatus] = useState(true)
   
    useEffect(() => {
        const auth = getAuth();
        onAuthStateChanged(auth, async (user) => {
          if (user) {
            setLoggedIn(true);
            const isAdmin = await fetchUserDetails(user.uid);
            setIsAdmin(isAdmin);
          } else {
            setLoggedIn(false);
            setIsAdmin(false);
          }
          setCheckingStatus(false);
        });
      }, []);

  return { loggedIn, checkingStatus, isAdmin}

}
